// extracted by mini-css-extract-plugin
module.exports = {"buttonStyle":"chargePage_buttonStyle__2ZJca","table":"chargePage_table__18i3O","total":"chargePage_total__19HBN"};